<div class="header">
  <h1 class="mat-body-1">{{ "ONSIP_I18N.ADD_A_PHONE_NUMBER" | translate }}</h1>
  @if (!showSearchScreen && !showPurchaseSpinner) {
  <h4 class="mat-body-2">
    {{
      "ONSIP_I18N.PSTN_CREDIT_REQUIRED__700_SETUP_AND_200_PER_MONTH_PER_PHONE_NUMBER" | translate
    }}
  </h4>
  } @if (showSearchScreen) {
  <h4 class="mat-body-2">Looking for available numbers. This may take a minute.</h4>
  } @if (showPurchaseSpinner) {
  <h4 class="mat-body-2">Purchasing numbers. This may take a minute.</h4>
  }
</div>
@if (!data?.disableToggles) { @if (!showSearchScreen && !showPurchaseSpinner) {
<div class="number-button-toggle">
  <mat-button-toggle-group [formControl]="buttonToggleFormControl" hideSingleSelectionIndicator>
    <mat-button-toggle value="single">Single number</mat-button-toggle>
    <mat-button-toggle value="multiple">Multiple numbers</mat-button-toggle>
  </mat-button-toggle-group>
</div>
} } @if (buttonToggleFormControl.value === 'single') {
<onsip-add-single-phone-number [npaNxxs]="npaNxxs" (closeDialog)="closeAddNumberForm()">
</onsip-add-single-phone-number>
} @else {
<onsip-add-multiple-phone-number
  [npaNxxs]="npaNxxs"
  (closeDialog)="closeAddNumberForm()"
  (showSearchScreen)="handleShowSearchScreen($event)"
  (showPurchaseSpinner)="handleShowPurchaseSpinner($event)"
>
</onsip-add-multiple-phone-number>
}
